import { ConstructionZone } from '@/features/saveSite/types';

export const getAllTasks = (constructionZones: ConstructionZone[]) => {
  const tasks = constructionZones.flatMap((constructionZone) => constructionZone.tasks);
  return tasks;
};
